<template>
  <div id="wave">
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
  </div>
</template>

<script>
export default {
  name: 'EcsTypingAnimation'
};
</script>

<style scoped>
#wave .dot {
  background-color: var(--v-surface-lighten5);
}
</style>
